<script setup lang="ts">
import { computed } from 'vue'

import AccountImpersonateListItem from '@/components/AccountImpersonateListItem.vue'
import AccountLogoutListItem from '@/components/AccountLogoutListItem.vue'
import AccountProfileListItem from '@/components/AccountProfileListItem.vue'
import { useAccountMenu } from '@/composables/useAccountMenu'
import { useThemeSelection } from '@/composables/useThemeSelection'
import { APP_BAR_AVATAR_BG, APP_BAR_ICON_COLOR, THEME_LABELS, VALID_THEMES } from '@/constants/practiceConstants'
import store from '@/store'

const { doStopImpersonate } = useAccountMenu()

const studentInitial = computed(() => store.getters.user.user?.username.charAt(0).toUpperCase())

const { isCurrentTheme, selectTheme } = useThemeSelection()
</script>

<template>
  <v-menu bottom left offset-y>
    <template #activator="{ props }">
      <v-btn
        v-if="!store.getters.user.impersonator"
        v-bind="props"
        class="mr-2"
        elevation="0"
        icon
        size="x-small"
        :style="{
          color: APP_BAR_ICON_COLOR,
          backgroundColor: APP_BAR_AVATAR_BG,
        }"
        >{{ studentInitial }}
      </v-btn>
      <v-btn v-else v-bind="props" color="warning">Impersonating As {{ store.getters.user.user?.firstName }}</v-btn>
    </template>

    <v-list>
      <account-profile-list-item />

      <v-divider />

      <account-impersonate-list-item />

      <v-list-item v-if="store.getters.user.impersonator" @click="doStopImpersonate">
        <v-list-item-title>Stop impersonation</v-list-item-title>
        <template #append>
          <v-icon color="error darken-2">mdi-incognito</v-icon>
        </template>
      </v-list-item>

      <v-list-group value="theme">
        <template #activator="{ props }">
          <v-list-item v-bind="props">
            <v-list-item-title>Theme</v-list-item-title>
            <template #append>
              <v-icon>mdi-palette</v-icon>
            </template>
          </v-list-item>
        </template>

        <v-list-item v-for="theme in VALID_THEMES" :key="theme" @click="selectTheme(theme)">
          <v-list-item-title>{{ THEME_LABELS[theme] }}</v-list-item-title>
          <template #prepend>
            <v-icon v-if="isCurrentTheme(theme)">mdi-check</v-icon>
            <div v-else style="width: 24px" />
          </template>
        </v-list-item>
      </v-list-group>

      <v-divider />

      <account-logout-list-item />
    </v-list>
  </v-menu>
</template>
